import React, { useState } from "react"
import { Image, Modal, Typography } from "antd"

const { Link } = Typography

const ViewDoneListTechnical = ({ link }) => {
  const [open, setOpen] = useState(false)

  const handleButtonClick = () => {
    // Directly show the modal when button is clicked
    setOpen(true)
  }

  return (
    <>
      <Link type="primary" onClick={handleButtonClick}>
        View
      </Link>
      <Modal
        title="Image Preview"
        open={open}
        width={250}
        footer={null} // No footer buttons
        onCancel={() => setOpen(false)} // Close modal when either clicking on the cancel button or outside the modal
      >
        {open ? <Image src={link} alt="Preview" style={{ width: "100%" }} /> : ""}{" "}
      </Modal>
    </>
  )
}

export default ViewDoneListTechnical
